import { SVGIconComponent } from './types';

export const ActionEnableLocker: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Action/EnableLocker" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M13,4 C17.9634032,4 22,8.03659677 22,13 C22,17.9634032 17.9634032,22 13,22 C8.03659677,22 4,17.9634032 4,13 C4,8.03659677 8.03659677,4 13,4 Z M13,5.56511286 C8.90089488,5.56511286 5.56511286,8.90057433 5.56511286,13 C5.56511286,17.0991051 8.90057433,20.4348871 13,20.4348871 C17.0991051,20.4348871 20.4348871,17.0994257 20.4348871,13 C20.4348871,8.90089488 17.0994257,5.56511286 13,5.56511286 Z M17.768769,9.23286158 C18.0718763,9.54872448 18.0780327,10.0675263 17.7810779,10.3899209 L11.0109615,17.7545109 C10.8663305,17.9116232 10.6678512,18 10.4616872,18 C10.4279323,18 10.3925444,17.9966432 10.3571577,17.9917338 C10.1155951,17.9573651 9.90481874,17.8018918 9.78787392,17.5760396 L8.09538421,14.3028652 C7.8907485,13.9068122 8.02614689,13.4092938 8.39849147,13.1916408 C8.77083606,12.9739753 9.23857201,13.1179949 9.4431959,13.514048 L10.6356077,15.8216307 L16.6809734,9.24595428 C16.9779282,8.92354713 17.4656736,8.91699868 17.768769,9.23286158 Z"
        id="Combined-Shape"
        fill="#848484"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
